import { DataSource, Label, Layout, Panel } from "@mcleod/components";

export abstract class AutogenLayoutCarrierInformationQuickInfo extends Layout {
    labelCarrierScac: Label;
    labelContractDescr: Label;
    labelDestContactEmail: Label;
    labelDestContactPhone: Label;
    labelDestLocation: Label;
    labelDestTerminalName: Label;
    labelDestinationTerminal: Label;
    labelOrigContactEmail: Label;
    labelOrigContactPhone: Label;
    labelOrigLocation: Label;
    labelOrigTerminalName: Label;
    labelOriginTerminal: Label;
    labelP44VendorInfo: Label;
    labelRatingSource: Label;
    labelScac: Label;
    labelService: Label;
    labelServiceLevel: Label;
    labelSource: Label;
    labelType: Label;
    panelDestinationTerminal: Panel;
    panelMain: Panel;
    panelOriginTerminal: Panel;
    panelTerminalInfo: Panel;
    sourceQuoteBillingFreightGroup: DataSource;
}
